import * as React from 'react'
import { useEffect } from 'react';
import styles from "./Who.module.css"
import { Link } from "react-router-dom"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const logo = "https://firebasestorage.googleapis.com/v0/b/odd-pleasures.appspot.com/o/OP%20Circle%20logo%20white.png?alt=media&token=79fbe546-0d40-4cae-9131-85c70aa45711"
const img1 = "https://firebasestorage.googleapis.com/v0/b/odd-pleasures.appspot.com/o/creative1.png?alt=media&token=cde06898-d585-4ee8-ac13-30deb45e625f"
const img2 = "https://firebasestorage.googleapis.com/v0/b/odd-pleasures.appspot.com/o/creative2.png?alt=media&token=556ab635-212b-4916-b1b5-2852bc4b9244"
const img3 = "https://firebasestorage.googleapis.com/v0/b/odd-pleasures.appspot.com/o/creative-01.png?alt=media&token=b0704eb2-5c42-4cbc-8bda-0cbca45171e4"
const img4 = "https://firebasestorage.googleapis.com/v0/b/odd-pleasures.appspot.com/o/creative-02.png?alt=media&token=bb2a13d3-a7b9-494a-8398-355bd6a0428c"

export default function Consulting() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, [])
    return (
        <section>
            <title>Events</title>
            <div className={styles.navBar}>
                <Link to="/who-we-are/detail?section=services">
                    <p className={styles.arrow}>Services</p>
                </Link>
                <Link to="/">
                    <img className={styles.logoNav} src={logo} alt="logo odd pleasures" />
                </Link>
            </div >
            <section className={styles.serviceDetail}>
                <h2 className={styles.title}>Creative consulting</h2>
                <div className={styles.serviceHeader}>
                    <div>
                        <p>Our team will provide consulting services for any type of artistic project. From businesses to individuals, we’ll help you elevate your project and bring your idea to life.
                        </p>
                    </div>
                    <a href="mailto:info@oddpleasures.com" aria-label="Mail" rel="noopener noreferrer">
                        <button className={styles.btn}>Book now</button>
                    </a>
                </div>
                <div className={styles.serviceContent}>
                    <LazyLoadImage effect="blur" src={img1} alt="services representation" />
                    <LazyLoadImage effect="blur" src={img2} alt="services representation" />
                    <LazyLoadImage effect="blur" src={img3} alt="services representation" />
                    <LazyLoadImage effect="blur" src={img4} alt="services representation" />
                </div>
            </section >
        </section>


    )
}